/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

export const RedoIcon = ({size = 24, color}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  const strokeColor = color ? iconColor : 'currentColor';
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <path d="M15 14L20 9L15 4" stroke={strokeColor} strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
      <path d="M20 9H9.5C8.04131 9 6.64236 9.57946 5.61091 10.6109C4.57946 11.6424 4 13.0413 4 14.5C4 15.2223 4.14226 15.9375 4.41866 16.6048C4.69506 17.272 5.10019 17.8784 5.61091 18.3891C6.64236 19.4205 8.04131 20 9.5 20H13"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinejoin="round" />
    </svg>
  );
};

export default RedoIcon;
